import * as TyreOfferParametersModels from '../../models/tyre-offer-parameters/tyre-offer-parameters';


export class Set {
  static readonly type = '[OfferParameters] Set';
  constructor(public Params: TyreOfferParametersModels.TyreOfferParameterModel, public Version: number) { }
}

export class Get {
  static readonly type = '[OfferParameters] Get';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[OfferParameters] DisposeSearch';
  constructor() { }
}
